/**
 * Calling-code helpers. The profile API returns the stored country code as it
 * was saved (`65`, `+65`, or, from older builds of this page, `++65`), so a
 * blind `'+' + code` adds a plus every time a number is saved again.
 */

/** "65", "+65", "++65" → "+65"; empty in, empty out. */
export function withLeadingPlus(code) {
  const bare = String(code ?? '')
    .trim()
    .replace(/^\++/, '');
  return bare ? `+${bare}` : '';
}
